import { sortOptionsByLabel, type LabeledOption } from '@/lib/sortOptions';
import type { AudioUploadMeta } from '@/lib/api';
import { LANGUAGES } from '@shared/voiceMeta';

// Audio-Metadaten-Optionen + Upload-Defaults — geteilt zwischen dem Multi-Upload-
// Staging (Detail-Bearbeiten-Modus + Sprachproben-Upload-Seite) und der Detail-Audio-Liste.
// Input-Limit (vor Konvertierung): großzügig, da jede Datei client-seitig zu einem
// kleinen MP3 192k normalisiert wird. Das konvertierte Ergebnis prüft der Worker
// separat gegen sein eigenes Limit.
export const MAX_UPLOAD_BYTES = 300 * 1024 * 1024;
export const UPLOAD_META_DEFAULTS: AudioUploadMeta = { category: null, language: 'de', dialect: null, accent: null, is_demomix: false, freetext_suffix: null };

// Kategorie/Dialekt/Akzent sind DB-gestuetzt (Etappe 5.5) — Options werden aus den
// per useVocabulary() geladenen Namenslisten gebaut, je mit „Ohne …"-Leerauswahl.
export function categoryOptions(names: readonly string[]) {
  return sortOptionsByLabel([{ value: '', label: 'Ohne Kategorie' }, ...names.map((n) => ({ value: n, label: n }))]);
}
export function dialectOptions(names: readonly string[]) {
  return sortOptionsByLabel([{ value: '', label: 'Kein Dialekt' }, ...names.map((n) => ({ value: n, label: n }))]);
}
export function accentOptions(names: readonly string[]) {
  return sortOptionsByLabel([{ value: '', label: 'Kein Akzent' }, ...names.map((n) => ({ value: n, label: n }))]);
}

// Haengt den aktuellen Wert als waehlbare „(Altwert)"-Option an, falls er nicht in
// der Options-Liste steht (Muster wie audioLanguageOptions). Leere/nullige Werte
// (bereits ueber die „Ohne …"-Leerauswahl abgedeckt) bleiben unveraendert.
export function withCurrent<T extends LabeledOption>(options: T[], current: string | null | undefined, suffix = '(Altwert)'): T[] {
  if (current && !options.some((o) => o.value === current)) {
    return [...options, { value: current, label: `${current} ${suffix}` } as T];
  }
  return options;
}

export const AUDIO_LANGUAGE_OPTIONS = sortOptionsByLabel(LANGUAGES.map((l) => ({ value: l.code, label: l.label })));

// Legacy-Sprachwerte, die nicht (mehr) in LANGUAGES stehen, als „(Altwert)" anhaengen,
// damit der aktuelle Wert im Dropdown darstellbar/waehlbar bleibt.
export function audioLanguageOptions(current: string) {
  return current && !LANGUAGES.some((l) => l.code === current)
    ? [...AUDIO_LANGUAGE_OPTIONS, { value: current, label: `${current} (Altwert)` }]
    : AUDIO_LANGUAGE_OPTIONS;
}
